export default __webpack_public_path__ + "static/media/ArrowDropDownRounded.add5d450.svg";